import Helpers from '../../javascripts/lib/helpers';
import HelpCentre from '../../javascripts/application/help-centre';

Helpers.ready(() => {
  new HelpCentre();
});
